import React, {useEffect, useState} from "react";
import SubHeader from "../../components/header/SubHeader";
import {useDispatch, useSelector} from "react-redux";
import {getTableColumns, getTableData} from "../../models/productModel";
import Table from "../../components/common/table/Table";
import {fetchProducts, resetUpdateStatus, resetEditStatus, resetProductManageStatus} from "../../store/product-slice";
import ActionButton from "../../components/actions/ActionButton";
import Button from "../../components/common/button/Button";
import {resetCreateStatus} from "../../store/product-slice";
import SearchInput from "../../components/common/form/SearchInput";
import Stack from "../../components/ui/Stack";

const ProductView = () => {
    const dispatch = useDispatch();
    const [searchText, setSearchText] = useState("");
    const {
        items,
        fetchStatus,
        createStatus,
        updateStatus,
        pagination,
        productManageStatus,
        editStatus,
        error
    } = useSelector(state => state.product);

    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        dispatch(fetchProducts({
            ...userRole,
        }));
    }, [dispatch, userRole]);

    useEffect(() => {
        if (updateStatus === "success") {
            dispatch(resetUpdateStatus());
        }
    }, [dispatch, updateStatus]);

    useEffect(() => {
        if (editStatus === "success") {
            dispatch(resetEditStatus());
        }
    }, [dispatch, editStatus]);

    useEffect(() => {
        if (createStatus === "success") {
            dispatch(resetCreateStatus());
        }
    }, [dispatch, createStatus]);

    useEffect(() => {
        if (productManageStatus === "success") {
            dispatch(resetProductManageStatus());
        }
    }, [dispatch, productManageStatus]);

    const tableColumns = getTableColumns();
    const tableData = getTableData({items});

    return (
        <>
            <SubHeader title="All Products">
                {userRole.scope === "Restaurant" &&
                    <Button to="add" className="btn-sm bg-primary bg-opacity-50">Add New</Button>}
                <ActionButton
                    permissions={['BranchAdmin', 'BranchOwner']}
                    to="update"
                    className="btn-sm bg-primary bg-opacity-50">Sync to List</ActionButton>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" &&
                <>
                    <Stack className="justify-content-between align-items-center">
                        <SearchInput value={searchText}
                                     onChange={(e) => setSearchText(e.target.value)}
                                     placeholder="Search by product name & tag..."
                                     columns={{md: 4, lg: 3}}
                                     className="mb-4"/>
                        <p className="mb-0 fs-md"><span className="text-secondary">Total Items:</span><span className="text-primary ms-1">{pagination?.results}</span></p>
                    </Stack>

                    <Table className="mobile-responsive mt-4" columns={tableColumns} data={tableData}
                           searchQuery={searchText} searchFields={["name", "tags"]}/>
                </>
            }
        </>
    );
};

export default ProductView;
